<template>
  <svg
    class="icon icon-wordpress"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 28 28"
    :width="width"
    :height="width"
  >
    <title>wordpress</title>
    <path d="M1.984 14c0-1.734 0.375-3.391 1.047-4.891l5.734 15.703c-4.016-1.953-6.781-6.062-6.781-10.813zM22.109 13.391c0 1.031-0.422 2.219-0.922 3.891l-1.188 4-4.344-12.906s0.719-0.047 1.375-0.125c0.641-0.078 0.562-1.031-0.078-0.984-1.953 0.141-3.203 0.156-3.203 0.156s-1.172-0.016-3.156-0.156c-0.656-0.047-0.734 0.938-0.078 0.984 0.609 0.063 1.25 0.125 1.25 0.125l1.875 5.125-2.625 7.875-4.375-13s0.719-0.047 1.375-0.125c0.641-0.078 0.562-1.031-0.078-0.984-1.937 0.141-3.203 0.156-3.203 0.156-0.219 0-0.484-0.016-0.766-0.016 2.141-3.266 5.828-5.422 10.031-5.422 3.125 0 5.969 1.203 8.109 3.156h-0.156c-1.172 0-2.016 1.016-2.016 2.125 0 0.984 0.578 1.813 1.188 2.812 0.469 0.797 0.984 1.828 0.984 3.313zM14.203 15.047l3.703 10.109c0.016 0.063 0.047 0.125 0.078 0.172-1.25 0.438-2.578 0.688-3.984 0.688-1.172 0-2.312-0.172-3.391-0.5zM24.531 8.234c0.938 1.719 1.484 3.672 1.484 5.766 0 4.438-2.406 8.297-5.984 10.375l3.672-10.594c0.609-1.75 0.922-3.094 0.922-4.312 0-0.438-0.031-0.844-0.094-1.234zM14 0c7.719 0 14 6.281 14 14s-6.281 14-14 14-14-6.281-14-14 6.281-14 14-14zM14 27.359c7.359 0 13.359-6 13.359-13.359s-6-13.359-13.359-13.359-13.359 6-13.359 13.359 6 13.359 13.359 13.359z"></path>
  </svg>
</template>

<script>
export default {
  name: 'wordPress',
  props: {
    width: {
      type: Number,
      default: 50,
      required: false
    }
  }
}
</script>
